
export default function BasicSpecs() {
  const specs = [
    { label: "カード名", value: "dカード GOLD U" },
    { label: "発行会社", value: "株式会社NTTドコモ" },
    // The slash inside the string is now safely enclosed in double quotes.
    { label: "国際ブランド", value: "Visa / Mastercard" },
    { label: "年会費", value: "3,300円（税込）※条件達成で実質無料" },
    { label: "申込対象", value: "満18歳以上29歳以下（高校生除く）" },
    { label: "基本還元率", value: "1.0%（100円につき1ポイント）" },
    { label: "ドコモ料金還元", value: "5%（1,000円につき50ポイント）" },
    { label: "ポイ活MAX還元", value: "最大11%（通常1%+キャンペーン10%）" },
    { label: "ahamoボーナス", value: "毎月+5GB（合計35GB利用可能）" },
    { label: "ケータイ補償", value: "購入から3年間、最大10万円" },
    { label: "国内旅行保険", value: "最高1,000万円" },
    { label: "海外旅行保険", value: "最高2,000万円" },
    { label: "お買物あんしん保険", value: "年間最大100万円" },
    { label: "空港ラウンジ", value: "国内・ハワイの主要空港無料" },
    { label: "電子マネー", value: "iD搭載" },
    { label: "タッチ決済", value: "Visa/Mastercardタッチ決済対応" },
    { label: "家族カード", value: "1枚1,100円（税込）" },
    {
      label: "ETCカード",
      value: "年会費無料（初年度無料、年1回利用で翌年無料）",
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-[#003366] mb-12">
          基本スペック
        </h2>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <table className="w-full">
            <tbody>
              {specs.map((spec, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                >
                  <th className="px-6 py-4 text-left text-sm font-bold text-[#003366] w-1/3 border-b border-gray-200">
                    {spec.label}
                  </th>
                  <td className="px-6 py-4 text-sm text-gray-700 border-b border-gray-200">
                    {spec.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
